import { HYPERLIQUID_DEX_PERP, HYPERLIQUID_DEX_SPOT } from './constants';
/** Round UP to `decimals` so a consolidated pool truly reaches the target. */
const roundUpToDecimals = (value, decimals) => {
    const factor = 10 ** decimals;
    return Math.ceil(value * factor) / factor;
};
/**
 * Pick the cheapest way to fund a withdrawal of `required` USDC (amount + headroom)
 * from the spot/perps split:
 *  - spot alone covers it  → withdraw from spot, no transfer
 *  - else perp alone covers → withdraw from perp, no transfer
 *  - else combined covers   → consolidate into the LARGER pool (minimizes the moved
 *    amount; ties prefer spot), then withdraw from it
 *  - else                   → insufficient
 *
 * The transfer `deficit` is rounded up to `decimals` (so the target reaches the
 * strictly-greater threshold) and clamped to the source pool's available balance.
 */
export function planWithdrawal(split, required, decimals) {
    const { spot, perps, combined } = split;
    if (spot >= required)
        return { sourceDex: HYPERLIQUID_DEX_SPOT };
    if (perps >= required)
        return { sourceDex: HYPERLIQUID_DEX_PERP };
    if (combined < required)
        return { insufficient: true };
    // Neither pool alone covers it; consolidate into the larger pool.
    const targetIsSpot = spot >= perps;
    const targetCurrent = targetIsSpot ? spot : perps;
    const sourceAvailable = targetIsSpot ? perps : spot;
    const deficit = Math.min(roundUpToDecimals(required - targetCurrent, decimals), sourceAvailable);
    return {
        sourceDex: targetIsSpot ? HYPERLIQUID_DEX_SPOT : HYPERLIQUID_DEX_PERP,
        // toPerp: true moves spot→perp (target = perp); false moves perp→spot (target = spot).
        transfer: { toPerp: !targetIsSpot, amount: deficit.toFixed(decimals) },
    };
}
